// extracted by mini-css-extract-plugin
module.exports = {"InnerWrapper":"Smaller_InnerWrapper__3me6p","ImageWrapper":"Smaller_ImageWrapper__T9F7K","Text":"Smaller_Text__Bv0ZB","Row":"Smaller_Row__1amoS"};